export const PANEL_OPEN = 'panel open';
export const PANEL_CLOSE = 'panel close';